import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import MediaQuery from "react-responsive"

import layoutConsts from "./layout-consts"

const headerStyles = {
  header: {
    background: `#fe4a49`,
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 10,
    paddingLeft: 20
  },
  linkWrapper: {
    margin: `0 auto`,
    maxWidth: layoutConsts.sitewidth,
    padding: "5px 0",
    alignItems: "center",
    display: "flex",
  },
  link: {
    color: "#fff",
    fontSize: "1.5em",
    padding: "0 20px",
    textDecoration: (currentPage, path) =>
      currentPage === path ? "underline" : "none",
  },
  siteTitle: {
    fontSize: "1.7em",
    margin: 0,
    float: "left",
    color: '#000',
    textDecoration: 'none',
  },
}

const Header = ({ siteTitle, currentPage }) => (
  <header style={headerStyles.header}>
    <div style={headerStyles.linkWrapper}>
      <Link to="/" style={headerStyles.siteTitle}>
        <MediaQuery maxDeviceWidth={600}>RL</MediaQuery>
        <MediaQuery minDeviceWidth={600}>{siteTitle}</MediaQuery>
      </Link>
      <Link
        to="/"
        style={{
          ...headerStyles.link,
          textDecoration: headerStyles.link.textDecoration(currentPage, "home"),
        }}
      >
        Work
      </Link>
      <Link
        to="/about"
        style={{
          ...headerStyles.link,
          textDecoration: headerStyles.link.textDecoration(
            currentPage,
            "about"
          ),
        }}
      >
        About
      </Link>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
